(() => {
  if (window.jstudioBuyNowReady) return;
  window.jstudioBuyNowReady = true;
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-jstudio-buy-now]');
    if (!button || button.disabled) return;
    const error = button.parentElement.querySelector('[data-jstudio-buy-error]');
    error.hidden = true;
    const form = document.getElementById(button.dataset.productForm);
    const addButton = form?.querySelector('button[name="add"]');
    if (!form || !addButton || addButton.disabled || !form.checkValidity()) {
      if (form && !form.checkValidity()) form.reportValidity();
      error.textContent = button.dataset.errorMessage;
      error.hidden = false;
      form?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      const data = new FormData(form);
      data.delete('sections');
      data.delete('sections_url');
      const response = await fetch(button.dataset.cartAddUrl, {
        method: 'POST',
        body: data,
        headers: { Accept: 'application/json' }
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || button.dataset.errorMessage);
      window.location.assign(button.dataset.checkoutUrl);
    } catch (failure) {
      error.textContent = failure.message || button.dataset.errorMessage;
      error.hidden = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();